import {
  put,
  select,
  delay,
  takeEvery,
} from 'redux-saga/effects';
import {
  getLogMessagesTimeout,
} from 'reducers';
import { hideLoggerMessage } from 'actions/logger';
import { logMessage } from '../reducers/logger';


export function* hideLogMessage(action) {
  const { id } = action.payload;
  const timeout = yield select(getLogMessagesTimeout);
  yield delay(timeout);
  yield put(hideLoggerMessage(id));
}

export default function* runLoggerSaga() {
  yield takeEvery(logMessage.type, hideLogMessage);
}
